<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Achat</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_achat.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <table>
                <tr>
                    <th>Prix de l’annonce</th>
                    <td *ngIf="favorite.ad.ai_id != 0">{{ favorite.ad.price|number:'1.0-1'}} €</td>
                    <td *ngIf="favorite.ad.ai_id == 0">{{ favorite.init_price|number:'1.0-1'}} €</td>
                </tr>
                <tr>
                    <th>Montant de l’offre</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <input matInput [(ngModel)]="favorite.price" (ngModelChange)="edit($event, 'price')">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Surface
                        <i *ngIf="favorite.lots.length > 1 && squareDetail == false" (click)="showSquareDetail()" class="fa fa-caret-down"></i>
                        <i *ngIf="favorite.lots.length > 1 && squareDetail == true" (click)="hideSquareDetail()" class="fa fa-caret-up"></i>
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Surface</mat-label>
                            <input matInput [(ngModel)]="favorite.square" (ngModelChange)="edit($event, 'square')" [disabled]="favorite.lots.length > 1">
                            <span matSuffix>m²</span>
                        </mat-form-field>
                    </td>
                </tr>
                <ng-container *ngIf="favorite.lots.length > 1 && squareDetail == true">
                    <tr *ngFor="let lot of favorite.lots; index as i;">
                        <th>{{ lot.title }}</th>
                        <td>
                            <mat-form-field appearance="standard">
                                <mat-label>Surface</mat-label>
                                <input matInput [(ngModel)]="lot.square" (ngModelChange)="edit($event, 'square')">
                                <span matSuffix>m²</span>
                            </mat-form-field>
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <th>Frais de notaire</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais de notaire</mat-label>
                            <input matInput [(ngModel)]="favorite.notary_price" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Meubles</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Meubles</mat-label>
                            <input matInput [(ngModel)]="favorite.furniture_price" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Travaux
                        <i *ngIf="favorite.lots.length > 1 && workDetail == false" (click)="showWorkDetail()" class="fa fa-caret-down"></i>
                        <i *ngIf="favorite.lots.length > 1 && workDetail == true" (click)="hideWorkDetail()" class="fa fa-caret-up"></i>
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Travaux</mat-label>
                            <input matInput [(ngModel)]="favorite.works_total" (ngModelChange)="edit($event, 'works_total')" [disabled]="favorite.lots.length > 1">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <ng-container *ngIf="favorite.lots.length > 1 && workDetail == true">
                    <tr *ngFor="let lot of favorite.lots; index as i;">
                        <th>{{ lot.title }}</th>
                        <td>
                            <mat-form-field appearance="standard">
                                <mat-label>Travaux</mat-label>
                                <input matInput [(ngModel)]="lot.works_total" (ngModelChange)="edit($event,'works_total', i)">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="authenticationService.currentUser.pro_plan != ''">
                    <th>
                        Architecte, maîtrise d'œuvre
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Total</mat-label>
                            <input matInput [(ngModel)]="favorite.other_fees_work" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>
                        <ng-container *ngIf="authenticationService.currentUser.pro_plan == ''">Autres frais (chasseur, architecte, MO ...)</ng-container>
                        <ng-container *ngIf="authenticationService.currentUser.pro_plan != ''">Frais de chasse</ng-container>
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Total</mat-label>
                            <input matInput [(ngModel)]="favorite.other_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Frais bancaires</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais bancaires</mat-label>
                            <input matInput [(ngModel)]="favorite.banking_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Frais de cautionnement</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais de cautionnement</mat-label>
                            <input matInput [(ngModel)]="favorite.deposit_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Total achat</th>
                    <td><b>{{ favorite.total_price|number:'1.0-1'}} €</b></td>
                </tr>
            </table>
        </div>
    </div>
</div>
